import { useTranslation } from 'react-i18next';

interface MandatoryInfoProps {
  productLink?: string;
}

export default function ProductMandatoryInfo({ productLink }: MandatoryInfoProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <a
      href={productLink + "#product_description_references"}
      className="product-card__mandatory_info"
      aria-label={t('search.hits.productCard.mandatoryInfo') as string}
    >
      <svg width="14" height="14" aria-hidden="true">
        <use href="#icon_square-arrow-up-right" />
      </svg>
      <span>{t('search.hits.productCard.mandatoryInfo')}</span>
    </a>
  );
}